<template>
  <div
    class="modal fade"
    id="postRequest"
    role="dialog"
    @click="$emit('close')"
  >
    <div class="modal-dialog modal-xl" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body">
          <div class="mr-l-10">タイトル</div>
          <input type="text" class="form-control" v-model="postRequest.title" />
          <div class="mr-l-10 mr-t-20">本文</div>
          <textarea
            class="w-rate-100 h-150 form-control"
            v-model="postRequest.content"
          />
        </div>
        <div class="modal-footer flexbox justify-right">
          <button
            type="button"
            class="btn btn-warning w-150 mr-r-10"
            data-dismiss="modal"
            @click="postNewRequest()"
            :disabled="isDisableButton"
          >
            投稿
          </button>
          <div data-dismiss="modal" @click="$emit('close')">
            <button class="btn ver-middle w-120">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RequestService from '@/services/requestservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      loader: null,
      postRequest: {
        title: '',
        content: ''
      }
    }
  },
  computed: {
    isDisableButton () {
      return !(this.postRequest.title.length && this.postRequest.content.length)
    }
  },
  created () {
    this.postRequest.title = localStorage.getItem('postTitle') || ''
    this.postRequest.content = localStorage.getItem('postContent') || ''
  },
  mounted () {
  },
  methods: {
    async postNewRequest () {
      let logParams = {
        name: eventCode.requests.click_post_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let self = this
      self.loader = self.$loading.show()
      const postRequestBody = {
        data: {
          type: 'requests',
          attributes: {
            title: self.postRequest.title,
            content: self.postRequest.content
          }
        }
      }

      await RequestService.postRequest(postRequestBody)
        .then(response => {
          this.postRequest.title = ''
          this.postRequest.content = ''
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
        .finally(() => {
          self.loader && self.loader.hide()
          self.$emit('close', true)
        })
    }
  },

  beforeDestroy () {
    localStorage.setItem('postTitle', this.postRequest.title)
    localStorage.setItem('postContent', this.postRequest.content)
    this.loader && this.loader.hide()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/request/PostRequest.vue